import { render, staticRenderFns } from "./BrowseFileModalComponent.vue?vue&type=template&id=35228e1c&scoped=true"
import script from "./BrowseFileModalComponent.vue?vue&type=script&lang=js"
export * from "./BrowseFileModalComponent.vue?vue&type=script&lang=js"
import style0 from "./BrowseFileModalComponent.vue?vue&type=style&index=0&id=35228e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35228e1c",
  null
  
)

export default component.exports